export const SET_BESCHWERDEN = "setBeschwerden";
export const SET_FILTER = "setFilter";
export const SET_TOTAL = "setTotal";
